import { render, staticRenderFns } from "./channel-form.vue?vue&type=template&id=b4eed03a"
import script from "./channel-form.vue?vue&type=script&lang=js"
export * from "./channel-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports